<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getFbaList,
  getFbaDetail,
  getFbaWarehouse,
  addFile,
  addRemark,
  exportFba,
  previewFba,
	del,
} from "@/api/forecastManagement/fbaList";
import { getAllClient } from "@/api/user/client";
import expandRow from "./template/index";
import cTable from "@/base/common/index";
import copyClick from "@/utils/copyClick";
import { getCountry } from "@/api/system/country";
import { getKeysType } from "@/api/public";
export default {
  name: "fbaList",
  components: {
    cTable
  },
  async mounted() {
    let client = (await getAllClient()).data.payload.rows;
    let warehouse = (await getFbaWarehouse()).data.payload;
    let country = (await getCountry()).data.payload;
    this.header.searchs.forEach(item => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "warehouse") item.options = warehouse;
      if (item.key === "to_country" || item.key === "from_country")
        item.options = country.rows;
    });
  },
  data() {
    return {
      config: {
        children: true,
        rowId: "id",
        showOverflow: false,
        mergeRows: ["subscribe_number"]
      },
      methods: {
        list: getFbaList,
        getFbaDetail,
        getFbaWarehouse,
        addFile,
        addRemark,
        exportFba,
        previewFba,
				del
      },
      modals: {
        remark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            rules: {
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 60
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          // {
          //   key: "time_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   component: "Select",
          //   options: [
          //     { label: this.$t("outboundTime"), value: 1 },
          //     { label: this.$t("inboundTime"), value: 2 }
          //   ],
          //   default: 1
          // },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "warehouse",
            placeholder() {
              return this.$t("select") + this.$t("warehouse_t");
            },
            component: "Select",
            options: []
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_depart");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              }
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getKeysType("FBA_KEYWORDS")).data.payload;
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 5 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("updateFile") + "FBA" + this.$t("data"),
              type: "1",
              fnName: "updateFile",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning"
              }
            },
            {
              name: () =>
                this.$t("Upload Appointment Number Doc"),
              type: "2",
              fnName: "updateFile",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning"
              }
            },
            {
              name: () => this.$t("specialSign") + this.$t("updateFile"),
              type: "3",
              fnName: "updateFile",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning"
              }
            },
            {
              name: () => this.$t("signDownload"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$t("export"),
              type: "exportList",
              fnName: "exportFun",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export({ searchForm, field }) {
              let data = {
                fba_id: this.selectAll.map(item => item.id)
              };
              this.openLoading();
              this.handleRequestMethods("exportFba", data, true, true).then(
                res => {
                  window.open(this.$globalUrl + res.payload.src);
                }
              );
            },
            updateFile({ file, searchForm, field }) {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("type", field.type);
              this.$page
                .handleRequestMethods("addFile", formData, true, true)
                .then(res => {
                  this.$page.getList();
                });
              return false;
            },
            exportFun({ searchForm, field }) {
              let data = {
                ...searchForm,
                export: 1
              };
              this.openLoading();
              this.handleRequestMethods("list", data, true, true).then(res => {
                window.open(this.$globalUrl + res.payload.src);
              });
            }
          }
        }
      },
      fields: [
        // {
        //   width: 35,
        //   type: "expand",
        //   showOverflow: false,
        //   // fixed: "left",
        //   expandRender: (h, p) => {
        //     return h(expandRow, {
        //       props: {
        //         row: p.row.expand
        //       }
        //     });
        //   },
        //   fnName: "expandFun",
        //   methods: {
        //     expandFun({ row }) {
        //       return row.id;
        //     }
        //   }
        // },

        {
          name: () => this.$t("appointmentNumber"),
          key: "subscribe_number",
          fixed: "left",
          minWidth: 150,
          copy: true
          // header: {
          //   copy: true
          // }
        },
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          width: 150
          // copy: true,
          // header: {
          //   copy: true
          // }
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "customerService",
          minWidth: 100
        },
        {
          name: () => this.$t("fabAccount"),
          key: "account",
          minWidth: 100
        },
        {
          name: () => this.$t("Company name"),
          key: "customer",
          minWidth: 100
        },

        {
          name: () => this.$t("shopName"),
          key: "store_name",
          type: "child",
          child: { list: "child", child: { list: "child" } },
          minWidth: 120
        },
        {
          name: () => "FBA" + this.$t("cargo_number"),
          minWidth: 120,
          type: "child",
          child: { list: "child", child: { list: "child" } },
          key: "product_code"
        },
        {
          name: () => this.$t("trackingNumber"),
          minWidth: 120,
          type: "child",
          child: { list: "child", child: { list: "child" } },
          key: "track_code"
        },
        {
          name: () => this.$t("deliveryAddress"),
          key: "warehouse",
          type: "child",
          child: { list: "child", child: { list: "child" } },
          minWidth: 100
        },
        {
          name: () => this.$t("Appointment delivery Date"),
          key: "deliver_date",
          type: "child",
          child: { list: "child", child: { list: "child" } },
          minWidth: 100
        },
        {
          name: () => this.$t("Appointment delivery Time"),
          key: "deliver_time",
          type: "child",
          child: { list: "child", child: { list: "child" } },
          minWidth: 100
        },
        {
          name: () => this.$t("invoicePCS"),
          key: "ctns",
          type: "child",
          child: { list: "child", child: { list: "child" } },
          minWidth: 100
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "pcs",
          type: "child",
          child: { list: "child", child: { list: "child" } },
          minWidth: 150
        },

        {
          name: () => this.$t("gather") + this.$t("invoicePCS"),
          key: "total_ctns",
          minWidth: 120
        },
        {
          name: () => this.$t("gather") + this.$t("noofpieces"),
          key: "total_pcs",
          minWidth: 120
        },
        {
          name: () => this.$t("allow_depart"),
          key: "from_country",
          minWidth: 120
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          minWidth: 100
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          minWidth: 150,
          type: "child",
          child: { list: "child", isToTip: true, component: "Button" },
          bind: {
            type: "success",
            size: "small"
          },
          methods: {
            click({ row }) {
              this.$page.getModal("remark").open(row, function() {
                this.setTitle(this.$t("order_desc") + row.product_code);
              });
            },
            render({ value }) {
              return value ? value : this.$t("addTo");
            }
          }
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 100,
          fixed: "right",
          list: [
            {
              name: () => this.$t("preview"),
              type: "preview",
              fnName: "previewFun",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("download"),
              type: "download",
              fnName: "downloadFun",
              bind: {
                type: "warning"
              },
              show: ({ row }) => {
                return row.enclosure;
              }
            },
						{
						  name: () => this.$t("delete"),
						  type: "delete",
						  fnName: "deleteFun",
						  bind: {
						    type: "error"
						  }
						},
          ],
          methods: {
						deleteFun({ row }) {
							this.$Modal.confirm({
								title: this.$t("delete"),
								width: 300,
								content: this.$t("titleModal"),
								onOk: () => {
									this.handleRequestMethods(
										"del",
										row.id,
										true,
										true
									).then((res) => {
										this.getList();
									});
								},
							});
						},
            previewFun({ row }) {
              this.handleRequestMethods("previewFba", row.id, false, true).then(
                res => {
                  if (res.payload.src) {
                    window.open(
                      this.$prviewUrl + this.$globalUrl + res.payload.src
                    );
                  } else {
                    this.$Message.error({
                      background: true,
                      content:
                        this.$t("Not") + this.$t("files") + this.$t("preview"),
                      duration: 5
                    });
                  }
                }
              );
            },
            downloadFun({ row }) {
              window.open(this.$globalUrl + row.enclosure);
            }
          }
        }
      ]
    };
  }
};
</script>
